import { PlayIcon } from '@mm/icons';
import { useInstagramCRUDActions } from '@mm/state/actions/InstagramCRUDActions';
import { LivechatMessageModel } from '@mm/state/model/LivechatMessageModel';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { colors } from '../../../../beta/styles/colors';
import { ImageMessage } from '../ImageMessage/ImageMessage';
import './IGStoryMessage.pcss';
import classNames from 'classnames';

type Props = {
  message: LivechatMessageModel;
  personName?: string;
  avatar?: string;
  css?: {
    container?: string;
    content?: string;
  };
};

export const IGStoryMessage = (props: Props) => {
  const { message, avatar, personName, css } = props;
  const fbPageId = useSelector(activeFacebookPageIdSelector);
  const { getIGStory } = useInstagramCRUDActions();
  const [isStoryLoaded, setIsStoryLoaded] = useState(false);
  const [link, setLink] = useState('');
  const [isImageType, setIsImageType] = useState(false);
  const isStoryExpired =
    Date.now() - Number(message.time) >= 24 * 60 * 60 * 1000;
  const isStoryMention =
    message?.structure?.promoterKind === 'instagram_story_mention';
  const isStoryReaction =
    message?.structure?.promoterKind === 'instagram_story_reaction';

  const loadStory = async () => {
    if (message.mid) {
      const storyResponse = await getIGStory(message.mid, fbPageId);
      setIsStoryLoaded(true);
      if (storyResponse?.story) {
        const { link } =
          storyResponse.story.mention || storyResponse.story.replyTo;
        // Start by guessing that it's an image and then we'll fall back to video if the image doesn't load
        setIsImageType(true);
        setLink(link);
      }
    }
  };

  const expiredStory = (
    <div className="ig-story-indicator ig-story-indicator--expired">
      <PlayIcon className="ig-story-indicator-icon" color={colors.darkGray} />
      Expired Story
    </div>
  );

  if (!isStoryLoaded) {
    return (
      <div
        className={classNames('ig-story-indicator__container', css?.container)}
      >
        {isStoryMention && (
          <span className="ig-story-indicator__title">
            Mentioned you in their story:
          </span>
        )}
        {isStoryReaction && (
          <span className="ig-story-indicator__title">
            Reacted to your story:
          </span>
        )}
        {!isStoryExpired ? (
          <div
            className={classNames('ig-story-indicator', css?.content)}
            onClick={loadStory}
          >
            <PlayIcon className="ig-story-indicator-icon" />
            Story
          </div>
        ) : (
          expiredStory
        )}
      </div>
    );
  }

  if (!link) {
    return expiredStory;
  }
  return isImageType ? (
    <ImageMessage
      url={link}
      messageDate={message.time}
      avatar={avatar}
      personName={personName}
      onImageLoadError={() => setIsImageType(false)}
    />
  ) : (
    <div className="ig-story__video-container">
      <video controls muted autoPlay loop className="ig-story__video">
        <source src={link} />
      </video>
    </div>
  );
};
